import { render, staticRenderFns } from "./ChartLawyerPlans.vue?vue&type=template&id=88e003c6&scoped=true"
import script from "./ChartLawyerPlans.vue?vue&type=script&lang=js"
export * from "./ChartLawyerPlans.vue?vue&type=script&lang=js"
import style0 from "./ChartLawyerPlans.vue?vue&type=style&index=0&id=88e003c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e003c6",
  null
  
)

export default component.exports